import { Mark, mergeAttributes } from "@tiptap/core"

const CommentHighlight = Mark.create({
  name: "commentHighlight",

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      "data-comment-id": { default: null },
      class: { default: "comment-highlight" },
    }
  },

  parseHTML() {
    return [
      { tag: "mark.comment-highlight" },
      { tag: "mark[data-comment-id]" },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ["mark", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addCommands() {
    return {
      setCommentHighlight: (attributes) => ({ commands }) => {
        return commands.setMark(this.name, attributes)
      },
      unsetCommentHighlight: () => ({ commands }) => {
        return commands.unsetMark(this.name)
      },
    }
  },
})

export default CommentHighlight
